import script from "./cc_submitters_autocomplete_v2.vue?vue&type=script&setup=true&lang=js"
export * from "./cc_submitters_autocomplete_v2.vue?vue&type=script&setup=true&lang=js"

import "./cc_submitters_autocomplete_v2.vue?vue&type=style&index=0&id=1b7d78d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b7d78d2"]])

export default __exports__